// extracted by mini-css-extract-plugin
export default {"shareViewWrapper":"index_shareViewWrapper__6vU+G","shareWrapper":"index_shareWrapper__0o9vr","stopButton":"index_stopButton__PbtfJ","shareDom":"index_shareDom__ego9h"};